<template>
<div class="app">
    <AppHeader fixed>
        <SidebarToggler class="d-lg-none" display="md" mobile />
        <b-link class="navbar-brand" to="#">
            <img class="navbar-brand-full" src="../assets/logo_bodytone_top_main2.png" height="35" alt="Bodytone logo">
            <img class="navbar-brand-minimized" src="../assets/logo_bodytone_top_main2.png" height="30" alt="Bodytone logo">
        </b-link>
        <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen=true />
        <b-navbar-nav class="d-md-down-none">
        <b-nav-item class="px-3" to="/dashboard"> </b-nav-item>
        <!-- <b-nav-item class="px-3" to="/users" exact>Users</b-nav-item>
        <b-nav-item class="px-3">Settings</b-nav-item>  -->
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
            <LanguageDropdown />
            <!-- <b-nav-item class="d-md-down-none">
          <DefaultHeaderDropdownNotif/>
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <DefaultHeaderDropdownTasks/>
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <DefaultHeaderDropdownMssgs/>
        </b-nav-item> -->
            <b-nav-item class="d-md-down-none">
                <!-- <DefaultHeaderDropdown/> -->
               
            </b-nav-item>
          
            <DefaultHeaderDropdownAccnt />
        </b-navbar-nav>
        <!-- <AsideToggler class="d-none d-lg-block" /> -->
        <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body">
        <AppSidebar fixed>
            <SidebarHeader />
            <SidebarForm />
            <SidebarNav :navItems="nav"></SidebarNav>
            
            
            <SidebarFooter ><img
                  class="navbar-brand-full"
                  src="../assets/compatiblestrava.png"
                  width="150"
                  alt="Strava logo"
              /></SidebarFooter>
            <SidebarMinimizer />
        </AppSidebar>
        <main class="main">
            <Breadcrumb :list="list" />
            <div class="container-fluid">
                <router-view></router-view>
            </div>
        </main>
        <AppAside fixed>
            <!--aside-->
            <DefaultAside />
        </AppAside>
    </div>
    <Footer>
        <div>
           
        </div>
        <div class="ml-auto">
            <a href="https://versades.com"><img src="../assets/logo_bodytone.png" alt="Bodytone" height="10px"></a>
            <span class="ml-1">&copy; 2019</span>    
      </div>
    </Footer>
</div>
</template>

<script>
import nav from "@/_nav";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer,
  Breadcrumb
} from "@coreui/vue";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
import LanguageDropdown from "./LanguageDropdown";
import { mapState } from "vuex";

export default {
  name: "DefaultContainer",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    Footer,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    LanguageDropdown,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data() {
    return {
      nav: nav.items
    };
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        route => route.name || route.meta.label
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard.vue